import React, { useState, useEffect } from 'react';
import { Accordion, Card, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { cloneDeep, isEmpty, set } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useTranslation } from 'react-i18next';
import DropdownCard from './DropdownCard';
import TextCard from './TextCard';
import DatePickerCard from './DatePickerCard';
import RadioButtonCard from './RadioButtonCard';
import Loader from '../../../Components/Utility/Loader/Loader';
import { SystemMasterSelect } from '../../../Components/helper';
import {
  getBrandDetails,
  getPCTypesDetails,
  getCustomAttributeFreeText,
  saveToSystemMaster,
  deleteFromSystemMasters,
  setActiveInactive,
} from '../Store/SystemMasters.action';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';
import { TEXT_ATTRIBUTE_CHAR_LIMIT_MAX } from './customAttribute.types';

function CustomAttrSave(isCustomAttr) {
  return isCustomAttr ? <Spinner animation="border" /> : <i className="icon-Tick-1 f-24" />;
}

const labelTmpObj = {
  keyName: null,
  isLable: true,
  type: null,
  isActive: true,
  isChecked: false,
  _id: '',
  isEmpty: false,
  isNew: true,
  productType: [],
};
const valueTmpObj = {
  keyName: null,
  isLable: false,
  type: null,
  lableId: null,
  isActive: true,
  isChecked: false,
  _id: '',
  isEmpty: false,
  isNew: true,
  productType: [],
  aliasName: '',
};

function CustomAttributeMaster({ OpenReArrangeFunction, parentState, parentSetState }) {
  const dispatch = useDispatch();
  const { CheckActionPermission } = useComponent();
  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights },
  } = reducer;
  const { customAttributeList } = SystemMastersDetails;
  const { userInfo } = UserDetails;
  const customAttributeMaster = 'custom-attribute-master';

  const MasterAddEditAccess = CheckActionPermission(logInRights, 'masters', 'customAttribute', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(logInRights, 'masters', 'customAttribute', 'delete');

  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;
  const [openList, setOpenList] = useState([]);
  const [isLoadingCustomAttr, setIsLoadingCustomAttr] = useState(false);
  const [showCustomAttr, setShowCustomAttr] = useState(false);
  const [isCustomAttrUnique, setIsCustomAttrUnique] = useState(true);
  const [buttonDownCustomAttr, setButtonDownCustomAttr] = useState(true);
  const [CustomAttrBtnDisable, setCustomAttrBtnDisable] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isCustomAttr, setIsCustomAttr] = useState(false);
  const [isUniqCustomAttrId, setIsUniqCustomAttrId] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const [scrollEl, setScrollEl] = useState(null);

  const [state, setState] = useState({
    dropDownTextList: [],
    modifiedList: [],
    activeType: {},
    dropdownOptionList: [],
  });

  const typeList = [
    { name: 'Dropdown', value: 'dropdown' },
    { name: 'Text', value: 'text' },
    { name: 'Date Picker', value: 'date-picker' },
    { name: 'Radio Button', value: 'radio-button' },
  ];

  const getCustomAttributeList = async () => {
    const params = {
      isFromMaster: true,
    };
    await Promise.all([
      dispatch(getCustomAttributeFreeText(params)),
      dispatch(getBrandDetails({ accessedFrom: 'masters', loggedInUserId })),
      dispatch(getPCTypesDetails({ tier: 'Tier1' }, true)),
    ]);
  };

  const callApi = async () => {
    setButtonDownCustomAttr(!buttonDownCustomAttr);
    setIsLoadingCustomAttr(true);
    setShowCustomAttr(buttonDownCustomAttr);
    getCustomAttributeList();
    setIsLoadingCustomAttr(false);
  };

  const handleValueChanged = (event, i, parentIndex) => {
    const valueText = [...state.modifiedList];
    if (event.target.name === 'aliasName') {
      valueText[parentIndex].values[i].aliasName = event.target.value;
    }
    if (event.target.name === 'keyName') {
      valueText[parentIndex].values[i].keyName = event.target.value;
    }
    setState((prevState) => ({
      ...prevState,
      modifiedList: valueText,
    }));
  };

  const handleChanged = (event, i) => {
    const freeTextDropdownData = [...state.modifiedList];
    freeTextDropdownData[i] = {
      ...freeTextDropdownData[i],
      keyName: event.target.value?.trimStart(),
      isEmpty: event.target.value === '',
    };

    setState((prevState) => ({
      ...prevState,
      modifiedList: freeTextDropdownData,
    }));
    setIsCustomAttrUnique(true);
    setIsUniqCustomAttrId([]);
    const arr = [];
    const arrIndex = [];
    freeTextDropdownData.forEach((ele, ind) => {
      freeTextDropdownData.forEach((objs, index) => {
        if (ele.keyName === objs.keyName && ind !== index) {
          arr.push(ele);
          arrIndex.push(index);
        }
      });
    });

    if (!isEmpty(arr)) {
      setIsUniqCustomAttrId([...arrIndex]);
    }
    setIsCustomAttrUnique(isEmpty(arr));
    let disableCustomAttr = false;
    freeTextDropdownData.forEach((CustomAttrElement) => {
      if (isEmpty(CustomAttrElement?.keyName?.trim())) {
        disableCustomAttr = true;
      }
    });
    setCustomAttrBtnDisable(disableCustomAttr);
  };

  useEffect(() => {
    if (scrollEl) {
      scrollEl.scrollTop = 1000;
    }
  }, [scrollEl]);

  /**
   * Removes the trailing white space left below the list after a multiselect dropdown
   * closes. While a dropdown is open the scroll container switches to overflow:visible,
   * allowing the scroll position to move past the content; on close (aria-expanded
   * flips to false) the position is clamped back so the last attribute sits flush at the bottom.
   */
  useEffect(() => {
    if (!scrollEl) {
      return undefined;
    }
    const clampScrollToBottom = () => {
      const maxScroll = Math.max(scrollEl.scrollHeight - scrollEl.clientHeight, 0);
      if (scrollEl.scrollTop > maxScroll) {
        scrollEl.scrollTop = maxScroll;
      }
    };
    const observer = new MutationObserver((mutations) => {
      const dropdownClosed = mutations.some(
        (mutation) => mutation.attributeName === 'aria-expanded' && mutation.target.getAttribute('aria-expanded') === 'false',
      );
      if (dropdownClosed) {
        window.requestAnimationFrame(clampScrollToBottom);
      }
    });
    observer.observe(scrollEl, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-expanded'],
    });
    return () => observer.disconnect();
  }, [scrollEl]);

  const handleDelete = (id, parentI) => {
    if (typeof id === 'number' || id === '') {
      if (typeof parentI === 'number') {
        state.modifiedList[parentI].values.splice(id, 1);
      } else {
        state.modifiedList.splice(id, 1);
      }

      state.modifiedList.forEach((CustomAttrElement) => {
        if (isEmpty(CustomAttrElement?.keyName?.trim()) && CustomAttrElement.isNew) {
          setCustomAttrBtnDisable(true);
        } else {
          setCustomAttrBtnDisable(false);
        }
      });
      setIsCustomAttrUnique(true);
      setIsUniqCustomAttrId([]);

      setState((prevState) => ({
        ...prevState,
        modifiedList: [...state.modifiedList],
      }));
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);

    const customAttributePara = {
      loggedInUserId,
      customAttributeId: deleteId,
      title: customAttributeMaster,
    };
    await dispatch(deleteFromSystemMasters(customAttributePara, t));

    setIsLoadingConf(false);
    setShowConfirmation(false);
    getCustomAttributeList();
  };

  const allData = [];
  const saveFreeTextDropdown = async () => {
    state.modifiedList?.forEach((ele) => {
      allData.push(ele);

      ele?.values?.forEach((eleChild) => {
        allData.push(eleChild);
      });
    });
    setIsCustomAttr(true);
    if (!isEmpty(allData)) {
      const emptyField = allData.filter(
        (custAttrItem) =>
          custAttrItem.keyName === null ||
          custAttrItem.keyName === '' ||
          custAttrItem.keyName.trim() === '' ||
          ((!custAttrItem?.productType || custAttrItem?.productType?.length === 0 || !custAttrItem?.brand || custAttrItem?.brand?.length === 0) &&
            !custAttrItem.lableId),
      );
      if (isEmpty(emptyField)) {
        const data = allData.map((nameObj) => {
          return { ...nameObj, name: nameObj.keyName.trim() };
        });
        const updatedData = data?.map((e) => {
          if (e.lableId) {
            delete e.productType;
            delete e.brand;
          }
          return e;
        });
        const custAttrParams = {
          keyNames: JSON.stringify(updatedData),
          title: customAttributeMaster,
        };
        await dispatch(saveToSystemMaster(custAttrParams, t));
        getCustomAttributeList();
        setState((prevState) => ({
          ...prevState,
          modifiedList: [],
        }));
      } else {
        const newState = state.modifiedList.map((item) =>
          item.keyName === null || ((!item?.productType || item.productType.length === 0 || !item?.brand || item.brand.length === 0) && !item.lableId)
            ? { ...item, isEmpty: true }
            : item,
        );

        setState((prevState) => ({
          ...prevState,
          modifiedList: newState,
        }));
      }
    }
    setIsCustomAttr(false);
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let c3 = {};
    state.modifiedList.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          title: customAttributeMaster,
        };
        c3 = data;
      } else if (ele?.values?.length > 0) {
        const valueEle = ele.values.find((eleValue) => eleValue._id === activeInactiveID);
        if (valueEle) {
          valueEle.isActive = !valueEle.isActive;
          const dataValue = {
            ...valueEle,
            loggedInUserId,
            title: customAttributeMaster,
          };
          c3 = dataValue;
        }
      }
    });
    await dispatch(setActiveInactive(c3, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);

    setState((prevState) => ({
      ...prevState,
      modifiedList: [...state.modifiedList],
    }));
  };

  const addValueForLabel = (id, index) => {
    const tempObj = cloneDeep(valueTmpObj);
    tempObj.lableId = id;
    const parent = state.modifiedList[index];
    if (parent?.type === 'radio-button' && (parent?.values?.length || 0) >= 2) {
      return;
    }
    tempObj.type = parent?.type === 'radio-button' ? 'radio-button' : 'dropdown';

    const freeTextDropdownData = [...state.modifiedList];

    const existingValue = freeTextDropdownData[index].values;
    existingValue?.push(tempObj);
    freeTextDropdownData[index] = {
      ...freeTextDropdownData[index],
      values: existingValue || [tempObj],
    };

    setState((prevState) => ({
      ...prevState,
      modifiedList: freeTextDropdownData,
    }));
  };

  const normalize = (arr) => (arr ? [...arr].sort((a, b) => a - b) : []);

  const addCustomAttr = async () => {
    if (state?.activeType !== null) {
      const tempObj = cloneDeep(labelTmpObj);
      if (state.activeType.value === 'text') {
        tempObj.isLable = false;
        tempObj.textFieldConfig = { charLimit: TEXT_ATTRIBUTE_CHAR_LIMIT_MAX };
      }
      if (state.activeType.value === 'date-picker') {
        tempObj.isLable = true;
      }
      if (state.activeType.value === 'radio-button') {
        tempObj.isLable = true;
      }

      tempObj.type = state.activeType.value;

      const tempProductType = normalize(tempObj.productType);
      const tempBrand = normalize(tempObj.brand);
      const existingCount = state.modifiedList.filter((item) => {
        return (
          JSON.stringify(normalize(item.productType)) === JSON.stringify(tempProductType) && JSON.stringify(normalize(item.brand)) === JSON.stringify(tempBrand)
        );
      }).length;

      if (existingCount >= 10) {
        toasterMsg(t('CUSTOM_ATTRIBUTES.MAX_ENTRIES'), t('MASTERS.DANGER'));
        return;
      }
      setState((prevState) => ({
        ...prevState,
        modifiedList: [...state.modifiedList, tempObj],
      }));
    }
  };

  const btnCall = () => {
    if (buttonDownCustomAttr === false) {
      return <i className="icon-new-down-arrow-icon icon-inverse f-24" />;
    }
    return <i className="icon-new-down-arrow-icon f-24" />;
  };

  const setModifiedData = (dropdownType, allTypeData) => {
    let filteredData = null;
    if (dropdownType.value === 'dropdown') {
      filteredData = allTypeData.filter((element) => element.isLable === true && element.type === 'dropdown');
    } else if (dropdownType.value === 'text') {
      filteredData = allTypeData.filter((element) => element.type === 'text');
      filteredData = filteredData.map((data) => {
        if (data?.textFieldConfig && data?.textFieldConfig?.charLimit <= 0) {
          data.textFieldConfig.charLimit = TEXT_ATTRIBUTE_CHAR_LIMIT_MAX;
        }
        return data;
      });
    } else if (dropdownType.value === 'date-picker') {
      filteredData = allTypeData.filter((element) => element.type === 'date-picker');
    } else if (dropdownType.value === 'radio-button') {
      filteredData = allTypeData.filter((element) => element.isLable === true && element.type === 'radio-button');
    }

    if (!isEmpty(filteredData)) {
      filteredData.forEach((item, i) => {
        const valuesForLabel = allTypeData.filter((ele) => item._id === ele.lableId);
        filteredData[i].values = valuesForLabel;
      });
      setState((prevState) => ({
        ...prevState,
        modifiedList: filteredData,
        activeType: dropdownType,
      }));
    }
  };

  const handleTypeChange = (dropdownType) => {
    const allTypeData = cloneDeep(state.dropDownTextList);
    if (CustomAttrBtnDisable) {
      setCustomAttrBtnDisable(false);
    }
    setState((prevState) => ({
      ...prevState,
      activeType: dropdownType,
      modifiedList: [],
      isUniqCustomAttrId: [],
    }));
    setModifiedData(dropdownType, allTypeData);
  };

  const handleCheckboxCA = (e) => {
    const id = e?.target?.id.split('_')[2];
    const list = state.modifiedList?.map((element) => {
      if (element?._id === id) {
        element.isChecked = e?.target?.checked;
      }
      return element;
    });
    setState((oldData) => ({ ...oldData, modifiedList: [...list] }));
  };

  const onDropSelectionChange = (e, i) => {
    const freeTextDropdownData = [...state.modifiedList];
    freeTextDropdownData[i] = {
      ...freeTextDropdownData[i],
      productType: e,
      isEmpty: e?.length === 0,
    };

    setState((prevState) => ({
      ...prevState,
      modifiedList: freeTextDropdownData,
    }));
  };

  const onDropBrandChange = (e, i) => {
    const freeTextDropdownData = [...state.modifiedList];
    freeTextDropdownData[i] = {
      ...freeTextDropdownData[i],
      brand: e,
      isEmpty: e?.length === 0,
    };

    setState((prevState) => ({
      ...prevState,
      modifiedList: freeTextDropdownData,
    }));
  };

  const renderDropdownCard = (card, index) => {
    return (
      <DropdownCard
        key={card?._id}
        index={index}
        item={card}
        handleChanged={handleChanged}
        addValueForLabel={addValueForLabel}
        handleValueChanged={handleValueChanged}
        activeInactiveClicked={activeInactiveClicked}
        handleDelete={handleDelete}
        isUniqueId={isUniqCustomAttrId}
        openList={openList}
        setOpenList={setOpenList}
        handleCheckboxCA={handleCheckboxCA}
        masterAddEditAccess={MasterAddEditAccess}
        masterDeleteAccess={MasterDeleteAccess}
        onDropSelectionChange={onDropSelectionChange}
        onDropBrandChange={onDropBrandChange}
      />
    );
  };

  const onChange = (value, i, path) => {
    let nextValue = value;
    if (path === 'textFieldConfig.charLimit') {
      if (value === '' || value === null || value === undefined) {
        nextValue = '';
      } else {
        const sanitized = String(value).replace(/\D/g, '');
        if (sanitized === '') return;
        const charLimit = parseInt(sanitized, 10);
        if (Number.isNaN(charLimit) || charLimit < 1 || charLimit > TEXT_ATTRIBUTE_CHAR_LIMIT_MAX) return;
        nextValue = charLimit;
      }
    }
    const freeTextDropdownData = [...state.modifiedList];
    set(freeTextDropdownData[i], path, nextValue);
    setState((prevState) => ({
      ...prevState,
      modifiedList: freeTextDropdownData,
    }));
  };

  const renderTextCard = (card, index) => {
    return (
      <TextCard
        key={card?._id}
        index={index}
        item={card}
        handleChanged={handleChanged}
        activeInactiveClicked={activeInactiveClicked}
        handleDelete={handleDelete}
        isUniqueId={isUniqCustomAttrId}
        onChange={onChange}
        handleCheckboxCA={handleCheckboxCA}
        onDropSelectionChange={onDropSelectionChange}
        onDropBrandChange={onDropBrandChange}
      />
    );
  };

  const renderDatePickerCard = (card, index) => {
    return (
      <DatePickerCard
        key={card?._id}
        index={index}
        item={card}
        handleChanged={handleChanged}
        activeInactiveClicked={activeInactiveClicked}
        handleDelete={handleDelete}
        isUniqueId={isUniqCustomAttrId}
        handleCheckboxCA={handleCheckboxCA}
        onDropSelectionChange={onDropSelectionChange}
        onDropBrandChange={onDropBrandChange}
      />
    );
  };

  const renderRadioButtonCard = (card, index) => {
    return (
      <RadioButtonCard
        key={card?._id}
        index={index}
        item={card}
        handleChanged={handleChanged}
        addValueForLabel={addValueForLabel}
        handleValueChanged={handleValueChanged}
        activeInactiveClicked={activeInactiveClicked}
        handleDelete={handleDelete}
        isUniqueId={isUniqCustomAttrId}
        openList={openList}
        setOpenList={setOpenList}
        handleCheckboxCA={handleCheckboxCA}
        masterAddEditAccess={MasterAddEditAccess}
        masterDeleteAccess={MasterDeleteAccess}
        onDropSelectionChange={onDropSelectionChange}
        onDropBrandChange={onDropBrandChange}
      />
    );
  };

  const renderAttributeCard = (card, index) => {
    if (card?.type === 'dropdown') return renderDropdownCard(card, index);
    if (card?.type === 'text') return renderTextCard(card, index);
    if (card?.type === 'date-picker') return renderDatePickerCard(card, index);
    if (card?.type === 'radio-button') return renderRadioButtonCard(card, index);
    return null;
  };

  useEffect(() => {
    if (!isEmpty(customAttributeList)) {
      setState((prevState) => ({
        ...prevState,
        dropDownTextList: customAttributeList,
      }));
    }
  }, [customAttributeList]);
  useEffect(() => {
    if (parentState?.rearrangeModal === 'customAttribute') {
      const activeValue = isEmpty(state?.activeType) ? 'dropdown' : state?.activeType?.value;
      const rearrangeTypePredicate = {
        dropdown: (element) => element?.isLable === true && element?.type === 'dropdown',
        text: (element) => element?.isLable === false && element?.type === 'text',
        'date-picker': (element) => element?.type === 'date-picker',
        'radio-button': (element) => element?.isLable === true && element?.type === 'radio-button',
      };
      const predicate = rearrangeTypePredicate[activeValue] || rearrangeTypePredicate.dropdown;
      const filteredData = customAttributeList.filter(predicate).map((data) => ({ name: data?.keyName, _id: data?._id }));
      parentSetState((prevState) => ({
        ...prevState,
        rearrangeData: filteredData,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customAttributeList, parentState?.rearrangeModal, state?.activeType]);

  useEffect(() => {
    if (isEmpty(state.activeType)) {
      handleTypeChange({ name: 'Dropdown', value: 'dropdown' });
    } else {
      handleTypeChange(state.activeType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.dropDownTextList]);

  return (
    <>
      <Accordion className="mb-4 master-accordian custom-attribute-master">
        <Card>
          <Card.Header>
            <div className="title-container">
              <p>{t('CUSTOM_ATTRIBUTES.CUSTOM_ATTRIBUTES_TITLE')}</p>
            </div>
            <div className={!MasterAddEditAccess ? 'action-title-btns single-btn' : 'action-title-btns'}>
              {MasterAddEditAccess && (
                <CustomTooltip tooltipText={t('CUSTOM_ATTRIBUTES.REARRANGE_TOOLTIP')}>
                  <button
                    type="button"
                    onClick={() => OpenReArrangeFunction('customAttribute')}
                    className="btn d-inline-flex mr-16 p-0"
                    disabled={CustomAttrBtnDisable || !isCustomAttrUnique}
                    aria-label="Rearrange"
                  >
                    <span className="icon-Rearrange text-grey  f-24" />
                  </button>
                </CustomTooltip>
              )}

              <CustomTooltip tooltipText={!buttonDownCustomAttr ? t('CUSTOM_ATTRIBUTES.CLOSE') : t('CUSTOM_ATTRIBUTES.OPEN')}>
                <button className="btn d-inline-flex p-0" onClick={() => callApi()} type="button">
                  {btnCall()}
                </button>
              </CustomTooltip>
            </div>
          </Card.Header>
          {showCustomAttr &&
            (isLoadingCustomAttr ? (
              <Loader />
            ) : (
              <Card.Body>
                <div className="select-container">
                  <Select
                    options={typeList}
                    placeholder={t('CUSTOM_ATTRIBUTES.TYPE_SELECT_PLACEHOLDER')}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option.value}`}
                    name="type"
                    value={state.activeType}
                    styles={SystemMasterSelect}
                    onChange={(e) => handleTypeChange(e)}
                    disabled={!MasterAddEditAccess}
                  />
                </div>
                <div className="common-custom-scrollbar" style={{ height: '500px', overflowY: 'auto' }}>
                  {Array.isArray(state?.modifiedList) &&
                    !isEmpty(state?.modifiedList) &&
                    state?.modifiedList?.map((ele, index) => {
                      return renderAttributeCard(ele, index);
                    })}
                </div>
                {MasterAddEditAccess && (
                  <CustomTooltip tooltipText={t('CUSTOM_ATTRIBUTES.ADD_TOOLTIP')}>
                    <button
                      type="button"
                      onClick={() => addCustomAttr()}
                      className="btn btn-outline ml-auto mr-2 mt-16 p-0"
                      disabled={CustomAttrBtnDisable || !isCustomAttrUnique}
                      aria-label="Add"
                      title="Add"
                    >
                      <span className="icon-Add text-grey  f-24" />
                    </button>
                  </CustomTooltip>
                )}
                <div className="select-container">
                  <div className="instruction-container mt-2  text-bold ">
                    <span className="important-span">* </span>
                    {t('CUSTOM_ATTRIBUTES.INSTRUCTION_MESSAGE')}
                  </div>
                </div>
                {MasterAddEditAccess && (
                  <div className="section-custom-save">
                    <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                      <button
                        aria-label="Save"
                        type="button"
                        className="btn mr-2 p-0"
                        onClick={saveFreeTextDropdown}
                        disabled={CustomAttrBtnDisable || !isCustomAttrUnique}
                      >
                        {CustomAttrSave(isCustomAttr)}
                      </button>
                    </CustomTooltip>
                  </div>
                )}
              </Card.Body>
            ))}
        </Card>
      </Accordion>
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('CUSTOM_ATTRIBUTES.DELETE_CONFIRM_TITLE')}
          message={t('CUSTOM_ATTRIBUTES.DELETE_CONFIRM_MESSAGE')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('CUSTOM_ATTRIBUTES.ACTIVE_DEACTIVATE_CONFIRM_TITLE')}
          message={t('CUSTOM_ATTRIBUTES.ACTIVE_DEACTIVATE_CONFIRM_MESSAGE')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}
export default CustomAttributeMaster;
